let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Kuyo")).then(() => parcelRequire('MUJuW'));